import { useEffect, useState } from 'react';

const DEFAULT_LOGO = '/assets/images/logos/logo.png';

export const useDynamicLogo = () => {
  const [logo, setLogo] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const loadLogo = async () => {
      try {
        // Try to load the default logo first
        const img = new Image();
        img.src = DEFAULT_LOGO;

        // Wait for the image to load or fail
        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
        });

        setLogo(DEFAULT_LOGO);
        console.log('[useDynamicLogo] Default logo loaded successfully');
      } catch (error) {
        console.error('[useDynamicLogo] Error loading default logo:', error);
        setError(error as Error);
        setLogo(null);
      } finally {
        setIsLoading(false);
      }
    };

    loadLogo();
  }, []);

  return { logo, isLoading, error };
};
